
    import './styles.scoped.css';
    export default {
  "filtering-token": "awsui_filtering-token_1heb1_1ayd6_5",
  "filtering-token-dismiss-button": "awsui_filtering-token-dismiss-button_1heb1_1ayd6_9",
  "filtering-token-select": "awsui_filtering-token-select_1heb1_1ayd6_13",
  "filtering-token-content": "awsui_filtering-token-content_1heb1_1ayd6_17",
  "filtering-token-inner": "awsui_filtering-token-inner_1heb1_1ayd6_21",
  "filtering-token-inner-dismiss-button": "awsui_filtering-token-inner-dismiss-button_1heb1_1ayd6_25",
  "filtering-token-inner-select": "awsui_filtering-token-inner-select_1heb1_1ayd6_29",
  "filtering-token-inner-content": "awsui_filtering-token-inner-content_1heb1_1ayd6_33",
  "filtering-token-edit-button": "awsui_filtering-token-edit-button_1heb1_1ayd6_37",
  "token-editor-field-property": "awsui_token-editor-field-property_1heb1_1ayd6_41",
  "token-editor-field-operator": "awsui_token-editor-field-operator_1heb1_1ayd6_45",
  "token-editor-field-value": "awsui_token-editor-field-value_1heb1_1ayd6_49",
  "token-editor-token-remove-actions": "awsui_token-editor-token-remove-actions_1heb1_1ayd6_53",
  "token-editor-token-add-actions": "awsui_token-editor-token-add-actions_1heb1_1ayd6_57",
  "token-editor-cancel": "awsui_token-editor-cancel_1heb1_1ayd6_61",
  "token-editor-submit": "awsui_token-editor-submit_1heb1_1ayd6_65",
  "property-editor-cancel": "awsui_property-editor-cancel_1heb1_1ayd6_69",
  "property-editor-submit": "awsui_property-editor-submit_1heb1_1ayd6_73"
};
  